<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()" fullscreen
      transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="importar($event)">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="margin-bottom: 80px;">
            <!-- START FORM DIALOG -->
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step">
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
              </v-col>
            </v-row>

            <v-row align="center" justify="center" class="mb-2">
              <v-col md="10" class="pt-0 pb-0">
                <v-chip color="primary" variant="outlined" size="small">
                  Tipo de producto seleccionado: <b class="ml-1">{{ modal_title }}</b>
                </v-chip>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col md="6" class="mt-4 pr-0 pl-0 ">
                  <v-form ref="form_step0" class="form-step0-excel">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[0].title }}</b>
                      </p>
                    </div>
                    <v-label>
                      Descargar la plantilla de importacion de productos.
                      <v-label @click="downloadExcel" class="text-download font-weight-bold ms-1 me-1">
                        Descargar
                      </v-label>

                    </v-label>

                    <v-file-input class="mt-3" accept=".xlsx" label="Seleccionar excel" v-model="excelFile"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)" persistent-hint></v-file-input>
                  </v-form>

                </v-col>
              </v-row>

              <!--step 2-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step1">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[1].title }}</b>
                      </p>
                    </div>
                    <v-alert v-if="headers_mismatch" type="error" class="mb-3">
                      {{ headers_mismatch_msg }}
                    </v-alert>

                    <v-progress-linear v-if="!headers_mismatch" v-model="percent" color="blue-grey" style="height: 25px !important"
                      class="mb-3 mt-3">
                      <strong>{{ Math.ceil(percent) || 0 }}%</strong>
                    </v-progress-linear>

                    <v-data-table v-if="!headers_mismatch" :headers="headers" :items="list_bulk" :search="search" :loading="loading_table"
                      class="simple-table" :items-per-page="5" dense>
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>{{ item.object.sku }}</td>
                          <td>{{ item.object.product_name }}</td>
                          <td>{{ item.object.client_username }}</td>
                          <td>{{ item.object.category_name }}</td>
                          <td>{{ item.object.sub_category_name }}</td>
                          <td>{{ item.object.product_type_name }}</td>
                          <td style="min-width: 200px">
                            <span v-if="item.loading">Procesando...</span>
                            <span v-else-if="item.status == 1 && item.status_create" class="text-green">Importado</span>
                            <span v-else-if="item.status == 1 && !item.status_create" class="text-red">{{ item.msg
                              }}</span>
                            <span v-else-if="item.status == 0">Pendiente de procesado</span>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-form>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions style="position: fixed; bottom: 0; right: 0; left: 0;">
            <v-row align="start" justify="center">
              <v-col cols="10" style="background-color: white;">

                <v-btn @click="prev" color="blue-grey" variant="outlined" v-if="step > 0">Atras</v-btn>
                <v-btn @click="goBack" color="blue-grey" variant="outlined" v-else-if="step == 0 && back_button">Atras</v-btn>
                <div class="float-right mr-2" v-if="step == 1">
                  <v-btn v-if="importaciones_no_creadas  > 0" @click="downloadErrorsExcel"  variant="outlined" color="primary" class="mr-2">
                    <v-icon left>mdi-download</v-icon>
                    Descargar Errores
                  </v-btn>
                  <v-chip color="success" class="mr-2">Importadas: {{ importaciones_creadas }}</v-chip>
                  <v-chip color="error" class="">Fallidas: {{ importaciones_no_creadas}}</v-chip>
                </div>

                <v-btn class="float-right" variant="outlined" color="primary" @click="readExcel" v-if="step == 0"
                  :disabled="excelFile == null && step == 0"> Siguiente</v-btn>

              </v-col>
              <v-col cols="12" style="background-color: #fafafa;border-top: 1px solid #c1c1c1;" class="text-end">
                <v-btn color="error" text @click="closeDialog()">Cerrar</v-btn>
                <v-btn color="success" text type="submit" :disabled="submit_disabled || headers_mismatch" :loading="loading"
                  v-if="!disabled && step == 1">{{ formBtn
                  }}</v-btn>

              </v-col>
            </v-row>

          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import readXlsxFile from "read-excel-file";
import { PRODUCT_COLUMNS } from "@/constants/ExcelColumnMappings";


export default {
  components: {},
  mixins: [ValidMixin, ExportMixin, AliasMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
    back_button: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      step: 0,
      steps: [
        {
          title: "Importar Excel",
          description: "Importe el Excel",
          content: "First-content",
        },
        {
          title: "Detalle del Excel",
          description: "Detalle del Excel",
          content: "Second-content",
        },
      ],
      excelFile: null,
      list_bulk: [],
      loading_create: false,
      importaciones_creadas: 0,
      importaciones_no_creadas: 0,
      total_importaciones: 0,
      submit_disabled: false,
      progress: 0,
      loading_table: false,
      headers_mismatch: false,
      headers_mismatch_msg: "",
    };
  },
  watch: {

  },
  mounted() {
  },

  computed: {
    headers() {
      const baseHeaders = [
        {
          title: "SKU",
          align: "left",
          sortable: true,
          key: "sku",
        },
        {
          title: "Nombre",
          align: "left",
          sortable: true,
          key: "product_name",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client_username",
        },
        {
          title: "Categoría",
          align: "left",
          sortable: true,
          key: "category_name",
        },
        {
          title: "Subcategoría",
          align: "left",
          sortable: true,
          key: "sub_category_name",
        },
        {
          title: "Tipo Producto",
          align: "left",
          sortable: true,
          key: "product_type_name",
        },
    
      ];


      // Agregar header de resultado
      baseHeaders.push({
        title: "Resultado",
        align: "left",
        sortable: false,
        key: "msg"
      });

      return baseHeaders;
    },
    percent: {
      get() {
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },

  methods: {
    downloadExcel() {
      const params = {}; // Agregar parámetros si son necesarios
      const fileName = 'plantilla_producto.xlsx';

      this.exportExcel(
        this.service.section + '/get-sample-excel',
        params,
        fileName
      );
    },
    getProcesadosValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },

    async readExcel() {
      this.step++;
      this.list_bulk = [];
      this.loading_table = true;
      this.headers_mismatch = false;
      this.headers_mismatch_msg = "";
      try {
        const rows = await readXlsxFile(this.excelFile);

        const headersOk = await this.validateHeadersVersion(rows[0]);
        if (!headersOk) {
          return;
        }

        for (const element of rows.slice(1)) { // Saltar el header
          const obj = {
            object: this.parseObject(element),
            msg: "",
            status: 0,
            status_create: false,
            loading: false,
          };
          this.list_bulk.push(obj);
        }

        this.total_importaciones = this.list_bulk.length;
      } catch (error) {
        console.error(error);
      }
      finally {
        this.loading_table = false;

      }
    },
    async validateHeadersVersion(uploadedHeadersRow) {
      try {
        const response = await this.service.get_excel_headers_version();
        const expectedHeaders = response.result.headers;

        if (!this.headersMatch(expectedHeaders, uploadedHeadersRow)) {
          this.headers_mismatch = true;
          this.headers_mismatch_msg =
            "El archivo no corresponde a la última versión del sistema. Por favor descargue nuevamente la plantilla actualizada.";
          return false;
        }
        return true;
      } catch (error) {
        console.error(error);
        this.headers_mismatch = true;
        this.headers_mismatch_msg = "No se pudo verificar la versión del Excel. Intente nuevamente.";
        return false;
      }
    },
    headersMatch(expectedHeaders, uploadedHeadersRow) {
      const uploaded = uploadedHeadersRow || [];
      for (let i = 0; i < expectedHeaders.length; i++) {
        const expectedValue = (expectedHeaders[i] || "").toString().trim();
        const uploadedValue = uploaded[i] != null ? uploaded[i].toString().trim() : "";
        if (expectedValue !== uploadedValue) {
          return false;
        }
      }
      return true;
    },
    parseObject(element) {
      const object = {
        sku: element[PRODUCT_COLUMNS.SKU] ? element[PRODUCT_COLUMNS.SKU].toString() : '',
        product_name: element[PRODUCT_COLUMNS.PRODUCTO] ? element[PRODUCT_COLUMNS.PRODUCTO].toString() : '',
        client_username: element[PRODUCT_COLUMNS.CLIENTE_USERNAME] ? element[PRODUCT_COLUMNS.CLIENTE_USERNAME].toString() : '',
        category_name: element[PRODUCT_COLUMNS.CATEGORIA] ? element[PRODUCT_COLUMNS.CATEGORIA].toString() : '',
        sub_category_name: element[PRODUCT_COLUMNS.SUBCATEGORIA] ? element[PRODUCT_COLUMNS.SUBCATEGORIA].toString() : '',
        product_type_name: element[PRODUCT_COLUMNS.TIPO_PRODUCTO] ? element[PRODUCT_COLUMNS.TIPO_PRODUCTO].toString() : '',
        proveedor: element[PRODUCT_COLUMNS.PROVEEDOR] ? element[PRODUCT_COLUMNS.PROVEEDOR].toString() : '',
        tipo_rotacion: element[PRODUCT_COLUMNS.TIPO_ROTACION] ? element[PRODUCT_COLUMNS.TIPO_ROTACION].toString() : '',
        frecuencia_rotacion: element[PRODUCT_COLUMNS.FRECUENCIA_ROTACION] ? element[PRODUCT_COLUMNS.FRECUENCIA_ROTACION].toString() : '',

        no_use_pallet_limit_in_picking: element[PRODUCT_COLUMNS.NO_APLICAR_LIMITE_PICKING] ? element[PRODUCT_COLUMNS.NO_APLICAR_LIMITE_PICKING].toString().toUpperCase() === 'SI' : false,
        use_strict_rotation_type: element[PRODUCT_COLUMNS.USAR_ROTACION_ESTRICTO] ? element[PRODUCT_COLUMNS.USAR_ROTACION_ESTRICTO].toString().toUpperCase() === 'SI' : false,

        tiene_control_por_lotes: element[PRODUCT_COLUMNS.CONTROL_LOTES] ? element[PRODUCT_COLUMNS.CONTROL_LOTES].toString().toUpperCase() === 'SI' : false,
        tiene_control_por_serie: element[PRODUCT_COLUMNS.CONTROL_SERIE] ? element[PRODUCT_COLUMNS.CONTROL_SERIE].toString().toUpperCase() === 'SI' : false,
        tiene_control_de_calidad: element[PRODUCT_COLUMNS.CONTROL_CALIDAD] ? element[PRODUCT_COLUMNS.CONTROL_CALIDAD].toString().toUpperCase() === 'SI' : false,
        requiere_fecha_expiracion: element[PRODUCT_COLUMNS.REQUIERE_FECHA_EXPIRACION] ? element[PRODUCT_COLUMNS.REQUIERE_FECHA_EXPIRACION].toString().toUpperCase() === 'SI' : false,
        // Los descriptivos siempre se leen del Excel (índices 14, 15, 16 = columnas O, P, Q)
        // aunque no estén habilitados en el sistema. Se envían al backend si corresponden.
        tiene_control_por_descriptivo_1: element[PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_1] ? element[PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_1].toString().toUpperCase() === 'SI' : false,
        tiene_control_por_descriptivo_2: element[PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_2] ? element[PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_2].toString().toUpperCase() === 'SI' : false,
        tiene_control_por_descriptivo_3: element[PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_3] ? element[PRODUCT_COLUMNS.CONTROL_DESCRIPTIVO_3].toString().toUpperCase() === 'SI' : false,
        unidad_almacenamiento: element[PRODUCT_COLUMNS.UNIDAD_ALMACENAMIENTO] ? element[PRODUCT_COLUMNS.UNIDAD_ALMACENAMIENTO].toString() : '',
        unidad_peso: element[PRODUCT_COLUMNS.UNIDAD_PESO] ? element[PRODUCT_COLUMNS.UNIDAD_PESO].toString() : '',
        unidad_medida: element[PRODUCT_COLUMNS.UNIDAD_MEDIDA] ? element[PRODUCT_COLUMNS.UNIDAD_MEDIDA].toString() : '',
        heigth: element[PRODUCT_COLUMNS.ALTO] ? parseFloat(element[PRODUCT_COLUMNS.ALTO]) || null : null,
        width: element[PRODUCT_COLUMNS.ANCHO] ? parseFloat(element[PRODUCT_COLUMNS.ANCHO]) || null : null,
        length: element[PRODUCT_COLUMNS.LARGO] ? parseFloat(element[PRODUCT_COLUMNS.LARGO]) || null : null,
        volume: element[PRODUCT_COLUMNS.VOLUMEN] ? parseFloat(element[PRODUCT_COLUMNS.VOLUMEN]) || null : null,
        codigo_barra_unidad: element[PRODUCT_COLUMNS.CODIGO_BARRA_UNIDAD] ? element[PRODUCT_COLUMNS.CODIGO_BARRA_UNIDAD].toString() : '',
        codigo_barra_caja: element[PRODUCT_COLUMNS.CODIGO_BARRA_CAJA] ? element[PRODUCT_COLUMNS.CODIGO_BARRA_CAJA].toString() : '',
        cantidad_unidades_caja: element[PRODUCT_COLUMNS.CANTIDAD_UNIDADES_CAJA] ? parseInt(element[PRODUCT_COLUMNS.CANTIDAD_UNIDADES_CAJA]) || null : null,
        cantidad_unidades_pallet: element[PRODUCT_COLUMNS.CANTIDAD_UNIDADES_PALLET] ? parseInt(element[PRODUCT_COLUMNS.CANTIDAD_UNIDADES_PALLET]) : 0,
      };

      return object;
    },

    formatDate(dateValue) {
      if (!dateValue) return '';

      // Si es una fecha de Excel (número)
      if (typeof dateValue === 'number') {
        const date = new Date((dateValue - 25569) * 86400 * 1000);
        return date.toISOString().split('T')[0];
      }

      // Si ya es una fecha válida
      if (dateValue instanceof Date) {
        return dateValue.toISOString().split('T')[0];
      }

      // Si es string, intentar parsearlo
      if (typeof dateValue === 'string') {
        const parsedDate = new Date(dateValue);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toISOString().split('T')[0];
        }
      }

      return '';
    },

    closeDialog() {
      this.$emit("updateDialog", false);
      this.step = 0;
      this.list_bulk = [];
      this.excelFile = null;
      this.importaciones_creadas = 0;
      this.importaciones_no_creadas = 0;
      this.total_importaciones = 0;
      this.submit_disabled = false;
      this.loading = false;
      this.loading_create = false;
      this.headers_mismatch = false;
      this.headers_mismatch_msg = "";
    },
    goBack() {
      this.step = 0;
      this.list_bulk = [];
      this.excelFile = null;
      this.importaciones_creadas = 0;
      this.importaciones_no_creadas = 0;
      this.total_importaciones = 0;
      this.submit_disabled = false;
      this.loading = false;
      this.loading_create = false;
      this.headers_mismatch = false;
      this.headers_mismatch_msg = "";
      this.$emit("back");
    },
    prev() {
      this.step--;
    },

    async importar() {
      var index = 0;
      this.loading_create = true;
      this.submit_disabled = true;

      for (const element of this.list_bulk) {
        if (this.list_bulk[index].msg == "" && !this.list_bulk[index].status_create && this.list_bulk[index].status == 0) {
          this.list_bulk[index].loading = true;
          let result = await this.createItem(this.list_bulk[index].object);

          this.list_bulk[index].loading = false;
          this.list_bulk[index].status = 1;
          this.list_bulk[index].status_create = result.status;
          this.list_bulk[index].msg = result.msg;

          if (result.status) {
            this.importaciones_creadas++;
          } else {
            this.importaciones_no_creadas++;
          }

        }

        index++;
      }

      this.loading_create = false;

      if (this.importaciones_creadas === this.list_bulk.length) {
        this.closeDialog();
        this.step = 0;
        this.list_bulk = [];
        this.excelFile = null;
        this.importaciones_creadas = 0;
        this.importaciones_no_creadas = 0;
        this.total_importaciones = 0;
        this.$emit('loadList');
      }

    },
    async createItem(item) {
      try {
        const response = await this.service.import_line_excel(item);
        return {
          status: response.status,
          msg: response.message || (response.status ? 'Importación exitosa' : 'Error en la importación:' + response.msg)
        };
      } catch (error) {
        return {
          status: false,
          msg: error.message || 'Error en la importación'
        };
      }
    },

    downloadErrorsExcel() {
      const errorsData = this.list_bulk.filter(item =>
        item.status === 1 && !item.status_create
      );

      if (errorsData.length === 0) {
        this.$toast.warning('No hay errores para descargar', 'Aviso');
        return;
      }

      // Usar el mismo endpoint get_sample_excel pero con datos de errores
      const params = {
        errors_data: errorsData
      };
      const fileName = `errores_importacion_productos.xlsx`;

      this.exportExcel(
        this.service.section + '/get-sample-excel',
        params,
        fileName
      );
    },
  },
};
</script>

<style scoped>
.text-download {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}

.text-download:hover {
  color: #1565c0;
  text-decoration: none;
}
</style>